<div [hidden]="!reportResult?.Columns?.length">
  <dx-data-grid biz-grid #dataGridVar [exportFileName]="reportName" [dataSource]='currentReportRows' [selection]='{ mode: "single" }' [showCollapseAllButton]="true"
    [bizHideSelectedRowsCompnent]="true">

    @for (column of reportResult?.Columns; track column) {
      @switch (convertDataType(column.ValueType)) {
        @case ('date') {
          <dxi-column [dataField]="column.Name" [caption]="column.Name" dataType="date" [format]="dateTimeService.getDevExpressDateTimeFunction"></dxi-column>
        }
        @case ('boolean') {
          <dxi-column [dataField]="column.Name" [caption]="column.Name" dataType="boolean"></dxi-column>
        }
        @case ('number') {
          <dxi-column [dataField]="column.Name" [caption]="column.Name" dataType="number"></dxi-column>
        }
        @case ('string') {
          <dxi-column [dataField]="column.Name" [caption]="column.Name" dataType="string"></dxi-column>
        }
      }
    }

  </dx-data-grid>
</div>
